import React, { useRef, useState } from "react";
import { SliderWrapper, HeaderText, 
    Label, BrokerLine, 
    SliderTrack, SliderThumb,
} from "./style";

const TextSizeAdjuster = ({ min = 10, max = 30, value, onChange }) => {
    const [fontSize, setFontSize] = useState((min + max) / 2);
    const trackRef = useRef(null);

    const numLines = 9;
    const numPositions = numLines * 2 - 1;
    const step = (max - min) / (numPositions - 1);

    // Calculate position and update font size while dragging
    const handleDrag = (e) => {
        const track = trackRef.current;
        if (!track) return;

        const rect = track.getBoundingClientRect();
        let percentage = ((e.clientX - rect.left) / rect.width);
        percentage = Math.max(0, Math.min(1, percentage));

        let position = Math.round(percentage * (numPositions - 1));
        let snappedValue = min + position * step;
        snappedValue = Math.round(snappedValue);
        snappedValue = Math.max(min, Math.min(max, snappedValue));

        setFontSize(snappedValue);
        if (onChange) onChange(snappedValue);
    };

    // Start tracking mouse movement
    const startDrag = () => {
        document.addEventListener("mousemove", handleDrag);
        document.addEventListener("mouseup", stopDrag);
    };

    // Stop tracking mouse movement
    const stopDrag = () => {
        document.removeEventListener("mousemove", handleDrag);
        document.removeEventListener("mouseup", stopDrag);
    };

    // Calculate the left percentage position of the thumb
    const safeValue = value ?? fontSize;
    const positionIndex = Math.round((safeValue - min) / step);
    const leftPercentage = (positionIndex / (numPositions - 1)) * 100;
    
    return (
        <SliderWrapper>
            <HeaderText>
                <Label small style={{ marginTop: "10px" }}>A</Label>
                <Label medium style={{ marginLeft: "6px" }}>A</Label>
                <Label large>A</Label>
            </HeaderText>
            <SliderTrack ref={trackRef}>
                <BrokerLine>
                    {Array.from({ length: numLines }, (_, i) => (
                        <React.Fragment key={i}>
                            <span>|</span>
                            {i < numLines - 1 && (
                                <span style={{ display: "inline-block", width: "calc((100% - 9px) / 8)" }} />
                            )}
                        </React.Fragment>
                    ))}
                </BrokerLine>
                <SliderThumb left={leftPercentage} onMouseDown={startDrag} />
            </SliderTrack>
        </SliderWrapper>
    );
};

export default TextSizeAdjuster;